import TicketsPage from "./teamTicket/TicketsPage";
import "./Onboarding.css";

export default function OnboardingPage() {
  return (
    <div className="onboarding">
      <h1 className="onboarding-title">Onboarding</h1>
      <TicketsPage />
    </div>
  );
}
